import React from 'react';

/**
 * Opening prompts, shown only before the first message.
 *
 * These come from the server so the wording can be tuned against what the
 * cohort actually asks, without a client build. They are framed as feedback
 * openers rather than support questions — the label a member taps sets their
 * expectation of what this is for, which matters more here than in a product
 * with a real support channel behind it.
 */

interface Props {
  prompts: string[];
  onSelect: (prompt: string) => void;
  disabled?: boolean;
}

export default function FeedbackSuggestedPrompts({ prompts, onSelect, disabled }: Props) {
  if (!prompts.length) return null;

  return (
    <div className="mb-4">
      <p
        className="text-[10px] uppercase tracking-[0.22em] mb-2.5"
        style={{ color: 'var(--melio-olive-deep)' }}
      >
        Not sure where to start
      </p>
      <div className="flex flex-wrap gap-2">
        {prompts.map((prompt) => (
          <button
            key={prompt}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(prompt)}
            className="text-[13px] px-3.5 py-1.5 rounded-full border bg-white transition-colors text-left"
            style={{
              borderColor: 'var(--melio-border)',
              color: 'var(--melio-text-muted)',
              opacity: disabled ? 0.5 : 1,
            }}
          >
            {prompt}
          </button>
        ))}
      </div>
    </div>
  );
}
